import React from "react";
import { useTranslation } from "react-i18next";
import { CloseCrossIcon } from "@/shared/icons";
import { SupportLinks } from "@/common/SupportLinks";
import type { ModalProps } from "antd/lib";
import { ModalWrapper } from "../ModalWrapper";
import styles from "./styles.module.scss";

export const ModalSupport: React.FC<ModalProps> = ({ ...props }) => {
  const { t } = useTranslation();

  const appVersion = window.__RUNTIME_CONFIG__.APP_VERSION;

  const classNames = {
    wrapper: styles["modal-support-wrapper"],
    mask: styles["modal-support-mask"],
    body: styles["modal-support-body"],
    content: styles["modal-support-content"],
    footer: styles["modal-support-footer"],
    header: styles["modal-support-header"],
  };

  return (
    <ModalWrapper
      type="delete"
      modalTitle={t("logInPage.contactUs")}
      className={styles.root}
      classNames={classNames}
      width={320}
      footer={false}
      closeIcon={<CloseCrossIcon width={12} height={12} className={styles["close-icon"]} />}
      closable
      {...props}
    >
      <>
        <SupportLinks className={styles.links} />
        <div className={styles["content-row"]}>
          {t("logInPage.version")}: {appVersion}
        </div>
      </>
    </ModalWrapper>
  );
};
